import DutchieScore from './dutchie-score';

export default DutchieScore;
